<app-menu-template3 *ngIf="authService.getTipoUser() !== tipo_administrador_cc || authService.getTipoUser() !== tipo_administrador_super">
  <ng-container *ngTemplateOutlet="perfil"></ng-container>
</app-menu-template3>
<app-side-menu1 *ngIf="authService.getTipoUser() === tipo_administrador_cc || authService.getTipoUser() === tipo_administrador_super">
  <ng-container *ngTemplateOutlet="perfil"></ng-container>
</app-side-menu1>

<ng-template #perfil>
  <main class="container">
    <div class="jumbotron jumbotron-fluid rounded mt-3 shadow bg-white p-0">
      <article class="container">
        <section class="row">
          <div class="col-md-12 d-flex justify-content-end pr-3">
            <img src="../../../../../assets/icons/edit_perfil.png" class="d-inline-block align-top position-absolute z-index pointer ml-4"
              alt="" (click)="onOpenModalProfile()">
          </div>
          <header class="col-sm-12 col-md-4 pl-3 m-auto text-center pb-3 pt-3">
            <img src="../../../../../assets/icons/profile.png" height="180" class="mb-3 mt-3" alt="">
            <p class="h4 perfil-color-dark perfil-text-large"><strong>{{prestadorModel.usuario}}</strong></p>
            <h1 class="h6 perfil-color-light">Mi perfil</h1>
          </header>
          <section class="col-sm-10 col-md-8 border-left pr-5 pl-5 mt-3" *ngIf="tipo_prestador === authService.getTipoUser(); else esFuncionario">
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Razón social</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.razon_social}}</label>
              </div>
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Tipo ID</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.desc_tipo_identificacion}}</label>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Número de identificación</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.numero_identificacion}}</label>
              </div>
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Representante legal</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.nombre_representante_legal}}</label>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Número ID representante legal</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.numero_identificacion_representante_legal}}</label>
              </div>
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Correo electrónico</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext perfil-text-large">{{prestadorModel.correo_electronico}}</label>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Correo electrónico reportado por {{authService.getRolDetalleUser() ===
                  tipo_prestador_no_comerciante ? 'DIAN' : 'RUES'}}</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext perfil-text-large">{{prestadorModel.correo_electronico_reportado}}</label>
              </div>
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Teléfono uno reportado por {{authService.getRolDetalleUser() ===
                  tipo_prestador_no_comerciante ? 'DIAN' : 'RUES'}}</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.telefono_reportado_1}}</label>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Teléfono dos reportado por {{authService.getRolDetalleUser() ===
                  tipo_prestador_no_comerciante ? 'DIAN' : 'RUES'}}</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.telefono_reportado_2}}</label>
              </div>
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Patrimonio Neto</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.patrimonio_neto |
                  currency:'COP'}}</label>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-sm-12 col-md-6 form-group">
                <label class="m-0 small">Actividades económicas</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">Ver actividades
                  <img src="../../../../../assets/icons/actividad-economica.png" height="30" class="pointer" alt=""
                    (click)="consultarActividades()">
                </label>
              </div>
              <div class="col-sm-12 form-group"
                  [ngClass]="{'col-md-3': prestadorModel.es_caja_compensacion, 'col-md-6': !prestadorModel.es_caja_compensacion}">
                <label class="m-0 small">Es Caja de Compensación</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">
                  {{prestadorModel.es_caja_compensacion ? 'Si' : 'No'}}
                </label>
              </div>
              <div class="col-sm-12 col-md-3 form-group" *ngIf="prestadorModel.es_caja_compensacion">
                <label class="m-0 small">Número del certificado</label>
                <label class="p-0 h6 font-weight-bold form-control-plaintext">
                  {{prestadorModel.numero_certificado || "-"}}
                </label>
              </div>
            </div>
          </section>
          <ng-template #esFuncionario>
            <section class="col-sm-10 col-md-8 border-left pr-5 pl-5 mt-3 align-self-center mb-5 mt-5">
              <div class="form-row mb-2">
                <div class="col-sm-12 col-md-6 form-group">
                  <label class="m-0 small">Nombre funcionario</label>
                  <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.razon_social}}</label>
                </div>
                <div class="col-sm-12 col-md-6 form-group">
                  <label class="m-0 small">Tipo ID</label>
                  <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.desc_tipo_identificacion}}</label>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-sm-12 col-md-6 form-group">
                  <label class="m-0 small">Número ID</label>
                  <label class="p-0 h6 font-weight-bold form-control-plaintext">{{prestadorModel.numero_identificacion}}</label>
                </div>
                <div class="col-sm-12 col-md-6 form-group">
                  <label class="m-0 small">Correo electrónico</label>
                  <label class="p-0 h6 font-weight-bold form-control-plaintext perfil-text-large">{{prestadorModel.correo_electronico_reportado}}</label>
                </div>
              </div>
            </section>
          </ng-template>
        </section>
      </article>
    </div>
  </main>
</ng-template>
